export default __webpack_public_path__ + "assets/drizzle.ae14aba4.svg";